__webpack_require__.p = "/Surya-Star-Holding/";